(function() {
  "use strict";
  var busy = false;
  var dirty = false;
  var undoState = null;
  function root() {
    return document.getElementById("cart-drawer") || document.querySelector(".hb-bag--page");
  }
  function bag() {
    var r = root();
    if (!r) return null;
    return r.matches("[data-bag]") ? r : r.querySelector("[data-bag]");
  }
  function host() {
    return document.getElementById("shopify-section-cart-drawer-section");
  }
  function dialogEl() {
    var r = root();
    return r ? r.querySelector("dialog") : null;
  }
  function figure(cents) {
    var n = Math.max(0, Math.round(cents));
    return {
      d: Math.floor(n / 100),
      r: n % 100
    };
  }
  function group(d) {
    return "$" + String(d).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  function money(cents) {
    var f = figure(cents);
    return f.r ? group(f.d) + "." + (f.r < 10 ? "0" : "") + f.r : group(f.d);
  }
  function tellBar(count) {
    try {
      document.dispatchEvent(new CustomEvent("shopify:cart:lines-update", {
        bubbles: true,
        detail: {
          itemCount: count,
          action: "change"
        }
      }));
    } catch (err) {}
  }
  function post(path, payload) {
    return fetch(path, {
      method: "POST",
      credentials: "same-origin",
      referrerPolicy: "same-origin",
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(payload)
    }).then(function(r) {
      return r.json().catch(function() {
        return null;
      }).then(function(data) {
        return {
          ok: r.ok,
          data
        };
      });
    });
  }
  function applyCart(cart) {
    if (!cart || !cart.items) return;
    var b = bag();
    if (!b) return;
    var byKey = {};
    cart.items.forEach(function(it) {
      byKey[it.key] = it;
    });
    b.querySelectorAll("[data-line]").forEach(function(row) {
      var it = byKey[row.getAttribute("data-key")];
      if (!it) return;
      row.setAttribute("data-qty", String(it.quantity));
      var w = row.querySelector("[data-qty-word]");
      if (w) w.textContent = String(it.quantity);
      var qbtn = row.querySelector("[data-bag-qty]");
      if (qbtn) qbtn.setAttribute("aria-label", "change quantity, " + it.quantity + " in the bag");
      var t = row.querySelector("[data-line-total]");
      if (t) t.textContent = money(it.final_line_price);
    });
    var total = b.querySelector("[data-bag-total]");
    if (total) total.textContent = money(cart.total_price);
    b.classList.toggle("is-empty", cart.item_count === 0);
    var uRow = b.querySelector("[data-bag-undo-row]");
    if (uRow) {
      var home = b.querySelector(cart.item_count === 0 ? "[data-bag-undo-home]" : "[data-bag-undo-slot]");
      if (home && uRow.parentElement !== home) home.appendChild(uRow);
    }
    tellBar(cart.item_count);
    tellHead(cart.item_count);
  }
  function tellHead(n) {
    var el = document.querySelector("[data-hb-cart-count]");
    if (!el) return;
    el.textContent = n === 0 ? "empty" : n === 1 ? "1 piece" : n + " pieces";
  }
  var pickFor = null;
  var pickReturn = null;
  function pickPanel() {
    var b = bag();
    return b ? b.querySelector("[data-bag-pick]") : null;
  }
  function closePick(refocus) {
    var p = pickPanel();
    if (p && !p.hidden) {
      p.hidden = true;
      while (p.firstChild) p.removeChild(p.firstChild);
    }
    var b = bag();
    if (b) b.classList.remove("is-picking");
    pickFor = null;
    if (refocus && pickReturn && document.contains(pickReturn)) {
      try {
        pickReturn.focus({
          preventScroll: true
        });
      } catch (err) {}
    }
    pickReturn = null;
  }
  function pickRow(n, note, cls) {
    var row = document.createElement("button");
    row.type = "button";
    row.className = "b-pick-row" + (cls ? " " + cls : "");
    row.setAttribute("data-pick-n", String(n));
    if (cls) row.disabled = true;
    var num = document.createElement("span");
    num.className = "n";
    num.textContent = String(n);
    row.appendChild(num);
    if (note) {
      var r = document.createElement("span");
      r.className = "r";
      r.textContent = note;
      row.appendChild(r);
    }
    return row;
  }
  function pickHead(lineRow) {
    var head = document.createElement("div");
    head.className = "b-pick-head";
    var nameEl = lineRow.querySelector(".hb-cgrid__name");
    var optsEl = lineRow.querySelector(".b-opts");
    var bits = [ "how many" ];
    if (nameEl) bits.push(nameEl.textContent.trim().toLowerCase());
    if (optsEl && optsEl.textContent.trim()) bits.push(optsEl.textContent.trim());
    var said = document.createElement("span");
    said.className = "w";
    said.textContent = bits.join(" · ");
    head.appendChild(said);
    var x = document.createElement("button");
    x.type = "button";
    x.className = "x";
    x.setAttribute("data-bag-pick-close", "");
    x.setAttribute("aria-label", "close");
    x.textContent = "✕";
    head.appendChild(x);
    return head;
  }
  function openPick(lineRow, opener) {
    var p = pickPanel();
    if (!p) return;
    closePick(false);
    pickFor = lineRow;
    pickReturn = opener || null;
    var qty = parseInt(lineRow.getAttribute("data-qty"), 10) || 1;
    var capAttr = lineRow.getAttribute("data-cap");
    var cap = capAttr === null || capAttr === "" ? null : parseInt(capAttr, 10);
    if (cap !== null && cap < qty) cap = qty;
    var top = cap === null ? Math.max(8, qty + 4) : Math.min(cap, 99);
    p.setAttribute("role", "group");
    p.setAttribute("aria-label", "quantity");
    p.appendChild(pickHead(lineRow));
    var focusTo = null;
    for (var n = 1; n <= top; n++) {
      var row = n === qty ? pickRow(n, "in the bag", "is-now") : pickRow(n, "", "");
      p.appendChild(row);
      if (n === Math.max(1, qty - 1)) focusTo = row;
    }
    if (cap !== null && cap < 99) p.appendChild(pickRow(cap + 1, "no stock left", "is-out"));
    p.hidden = false;
    var b = bag();
    if (b) b.classList.add("is-picking");
    var first = p.querySelector(".b-pick-row:not([disabled])");
    try {
      (focusTo && !focusTo.disabled ? focusTo : first).focus({
        preventScroll: true
      });
    } catch (err) {}
  }
  function pickQty(n) {
    var row = pickFor;
    closePick(true);
    if (!row || busy) return;
    var qty = parseInt(row.getAttribute("data-qty"), 10) || 0;
    if (n === qty) return;
    busy = true;
    post("/cart/change.js", {
      id: row.getAttribute("data-key"),
      quantity: n
    }).then(function(res) {
      busy = false;
      if (res.ok && res.data) {
        dirty = true;
        applyCart(res.data);
      }
    }).catch(function() {
      busy = false;
    });
  }
  function buildUndoRow(title) {
    var u = document.createElement("div");
    u.className = "b-undo";
    u.setAttribute("data-bag-undo-row", "");
    var w = document.createElement("span");
    w.className = "w";
    w.textContent = "removed · " + title;
    u.appendChild(w);
    var go = document.createElement("button");
    go.type = "button";
    go.className = "b-undo-go";
    go.setAttribute("data-bag-undo", "");
    var word = document.createElement("span");
    word.className = "u";
    word.textContent = "undo";
    go.appendChild(word);
    u.appendChild(go);
    return u;
  }
  function clearUndo() {
    var b = bag();
    if (b) b.querySelectorAll("[data-bag-undo-row]").forEach(function(n) {
      n.remove();
    });
    undoState = null;
  }
  function removeLine(lineRow) {
    if (busy) return;
    if (pickFor === lineRow) closePick(false);
    var nameEl = lineRow.querySelector(".hb-cgrid__name");
    var title = nameEl ? nameEl.textContent.trim() : "";
    var key = lineRow.getAttribute("data-key");
    var b0 = bag();
    var siblings = b0 ? Array.prototype.slice.call(b0.querySelectorAll("[data-line]")) : [];
    var idx = siblings.indexOf(lineRow);
    busy = true;
    post("/cart/change.js", {
      id: key,
      quantity: 0
    }).then(function(res) {
      busy = false;
      if (!res.ok || !res.data) return;
      dirty = true;
      clearUndo();
      lineRow.remove();
      undoState = {
        row: lineRow,
        key,
        vid: parseInt(lineRow.getAttribute("data-vid"), 10),
        qty: parseInt(lineRow.getAttribute("data-qty"), 10) || 1,
        title,
        idx: idx < 0 ? 0 : idx
      };
      var b = bag();
      var slot = b ? b.querySelector("[data-bag-undo-slot]") : null;
      if (slot) slot.appendChild(buildUndoRow(title));
      applyCart(res.data);
    }).catch(function() {
      busy = false;
    });
  }
  function undo() {
    var u = undoState;
    if (!u || busy) return;
    busy = true;
    post("/cart/add.js", {
      id: u.vid,
      quantity: u.qty
    }).then(function(res) {
      busy = false;
      if (!res.ok || !res.data || res.data.status) return;
      dirty = true;
      var b = bag();
      var lines = b ? b.querySelector("[data-bag-lines]") : null;
      if (lines) {
        var at = lines.querySelectorAll("[data-line]")[u.idx];
        if (at) lines.insertBefore(u.row, at); else lines.appendChild(u.row);
      }
      clearUndo();
      return fetch("/cart.js", {
        credentials: "same-origin",
        headers: {
          Accept: "application/json"
        }
      }).then(function(r) {
        return r.json();
      }).then(function(cart) {
        if (cart && cart.items) {
          var mine = cart.items.filter(function(it) {
            return it.variant_id === u.vid;
          })[0];
          if (mine && u.row) u.row.setAttribute("data-key", mine.key);
        }
        applyCart(cart);
      });
    }).catch(function() {
      busy = false;
    });
  }
  function resync() {
    if (!dirty) return;
    dirty = false;
    fetch("/?sections=cart-drawer-section", {
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      },
      cache: "no-store"
    }).then(function(r) {
      return r.json();
    }).then(function(data) {
      var html = data && data["cart-drawer-section"];
      var h = host();
      if (!html || !h) return;
      var doc = (new DOMParser).parseFromString(html, "text/html");
      var next = doc.getElementById("shopify-section-cart-drawer-section");
      h.innerHTML = next ? next.innerHTML : html;
    }).catch(function() {
      dirty = true;
    });
  }
  var watched = null;
  function wireDialog() {
    var d = dialogEl();
    if (!d || d === watched) return;
    watched = d;
    new MutationObserver(function() {
      if (!d.hasAttribute("open")) {
        closePick(false);
        clearUndo();
        resync();
      }
    }).observe(d, {
      attributes: true,
      attributeFilter: [ "open" ]
    });
  }
  function wireHost() {
    var h = host();
    if (!h || h._hbBagObs) return;
    h._hbBagObs = true;
    new MutationObserver(function() {
      if (dialogEl() === watched) return;
      watched = null;
      pickFor = null;
      undoState = null;
      wireDialog();
    }).observe(h, {
      childList: true,
      subtree: true
    });
  }
  document.addEventListener("click", function(e) {
    var r = root();
    if (!r || !r.contains(e.target)) {
      if (pickFor) closePick(false);
      return;
    }
    var qbtn = e.target.closest("[data-bag-qty]");
    if (qbtn) {
      var line = qbtn.closest("[data-line]");
      if (pickFor === line) {
        closePick(true);
        return;
      }
      if (line) openPick(line, qbtn);
      return;
    }
    if (e.target.closest("[data-bag-pick-close]")) {
      closePick(true);
      return;
    }
    var opt = e.target.closest(".b-pick-row");
    if (opt) {
      if (opt.disabled || opt.classList.contains("is-now") || opt.classList.contains("is-out")) return;
      pickQty(parseInt(opt.getAttribute("data-pick-n"), 10));
      return;
    }
    var rm = e.target.closest("[data-bag-remove]");
    if (rm) {
      var row = rm.closest("[data-line]");
      if (row) removeLine(row);
      return;
    }
    if (e.target.closest("[data-bag-undo]")) {
      undo();
      return;
    }
    if (pickFor && !e.target.closest("[data-bag-pick]")) closePick(false);
  });
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape" && pickFor) {
      e.preventDefault();
      e.stopPropagation();
      closePick(true);
    }
  }, true);
  function boot() {
    wireDialog();
    wireHost();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();